export const ALERT_TITLE_OPTIONS = {
  success: 'SUCCESS',
  info: 'INFO',
  warning: 'WARNING NOTICE',
  error: "ERROR - WE COULDN'T MAKE THAT CHANGE",
};
